import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-crm_statistiche",
    templateUrl: "./crm_statistiche.component.html",
    styleUrls: ["./crm_statistiche.component.css"],
})
export class CrmStatisticheComponent implements OnInit {
    constructor() { }
    ngOnInit(): void { }
}
